import { Button } from 'flowbite-react';
import { Img } from 'react-image';

const tips = [
	'1. Ensure you are in a quiet, distraction-free area.',
	'2. Check you have enough charge on your device and a good data connection.',
	'3. Practice to feel comfortable with the process.',
	'4. Make eye contact with the camera whenever possible.',
	'5. Remember to grant access to your camera and microphone when requested.',
];

const questions = [
	'Your quick introduction and overview of your academic qualifications.',
	'Your key technical projects, your role in them, and the technologies you have worked on.',
	'Your future vision on your tech career',
];

interface Props {
	onClick: () => void;
}

const VideoResumeStaticScreen = ({ onClick }: Props) => {
	return (
		<div className="mt-[16px] w-full max-w-[1120px] rounded-[16px] bg-[#1F2A37] p-[62px] pb-[30px] sm:mb-[40px] sm:px-[16px] sm:py-[24px]">
			<div className="flex w-full justify-center text-2xl font-bold text-white">
				<div className="w-full max-w-[568px]">Introductory Video</div>
			</div>
			<div className="mt-[32px] flex justify-center">
				<Img loading="lazy" src="/assets/videoResumeGraphic.svg" alt="videoResumeGraphic" width="390" height="248" />
			</div>
			<div className="mt-[36px] flex w-full justify-center text-base font-normal text-white">
				<div className="w-full max-w-[568px]">
					We recognize that you are more than just a resume. Your voice matters, and your individuality sets you apart.
					You need to respond to the following questions:
				</div>
			</div>

			<div className="mt-[10px] flex w-full justify-center">
				<div className="max-w-[568px] rounded-[8px] bg-[#18222D] px-4 py-[20px] text-sm font-normal text-white">
					{questions.map((q, i) => (
						<div key={q} className="flex gap-[3px]">
							<div>{i + 1}.</div>
							<div>{q}</div>
						</div>
					))}
				</div>
			</div>

			<div className="mt-[32px] flex w-full justify-center text-lg font-medium text-white">
				<div className="w-full max-w-[568px]">Top tips for recording your video responses</div>
			</div>

			<div className="mt-[16px] flex w-full justify-center">
				<div className="w-full max-w-[560px] text-sm font-normal text-[#C7C9D9]">
					{tips.map(t => (
						<div key={t}>{t}</div>
					))}
				</div>
			</div>

			<div className="mt-[24px] flex justify-center">
				<Button color="purplePlaced" onClick={onClick}>
					Next
				</Button>
			</div>
		</div>
	);
};

export default VideoResumeStaticScreen;
